// Browser-local history of portraits this visitor generated, so the landing
// page can show a "Recent Portraits" strip (like WooCommerce) that links back
// to the standalone preview page. The bridge has no cross-generation session
// (a fresh session_token is minted per generate), so this lives in
// localStorage keyed per browser.

export interface RecentPortrait {
  jobId: string;
  previewUrl: string;
  styleName?: string;
  createdAt: string;
}

const KEY = 'apb_recent_portraits';
const MAX = 12;

// This bridge's own job_id is always "ark_<ts>_<hex>" (GenerateHandler::
// makeJobId()). The newer version2 bridge writes to this exact same
// localStorage key on the same domain with its own UUID ids — a browser
// that used both eras ends up with a mixed list. Clicking a foreign-era id
// doesn't take the visitor to the system that can actually resolve it (both
// widgets just swap `?id=` on the CURRENT page), so it always 404s.
// Filtering here means this (v1) strip only ever shows its own jobs.
const ARK_RE = /^ark_\d+_[0-9a-f]+$/i;

export function getRecentPortraits(): RecentPortrait[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr)
      ? arr.filter((x): x is RecentPortrait => !!x && typeof x.jobId === 'string' && ARK_RE.test(x.jobId) && typeof x.previewUrl === 'string')
      : [];
  } catch {
    return [];
  }
}

/** Prepend a portrait (most-recent first), dedupe by jobId, cap the list. */
export function saveRecentPortrait(p: RecentPortrait): void {
  if (typeof localStorage === 'undefined') return;
  try {
    const list = getRecentPortraits().filter((x) => x.jobId !== p.jobId);
    list.unshift(p);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* private mode / quota — ignore, the strip just won't show */
  }
}
